<template>
    <v-autocomplete
        :items="listaIndicadores"
        item-value="id"
        item-text="nombre"
        solo
        hide-details
        :label="textoSelector"
        @change="indicadorSeleccionado"
    >
    </v-autocomplete>
</template>
<script>
import IndicadoresService from "@services/IndicadoresService";

export default {
    name: "BuscadorIndicadores",
    data: function () {
        return {
            listaIndicadores: [],
            textoSelector: this.$t("componentes.buscador-indicadores.label"),
        };
    },
    mounted() {
        IndicadoresService.getNombreIndicadores().then((response) => {
            this.listaIndicadores = response.data;
        });
    },
    methods: {
        indicadorSeleccionado(id) {
            this.$emit("busqueda");
            this.$router.push({
                name: "detalles",
                params: { id: id },
            });
        },
    },
};
</script>
